export const DEFAULT_ROW = {
    plug_type: "" as const,
    count: "" as const,
    amount_kw: "" as const,
};

export const DEFAULT_VALUES = {
    plugs: [{ ...DEFAULT_ROW, index: 0 }],
    isProjectSizeUnknown: false,
};
